import React from "react";
import { Box, Text } from "@thenounproject/lingo-core";

type Props = {
  text: string;
  style: "light" | "dark" | "darkGradient" | "lightGradient";
};

function getBackgroundColor(style: "light" | "dark" | "darkGradient" | "lightGradient") {
  return style.startsWith("dark") ? "primaryDarkest" : "primaryLightest";
}

function getTextColor(style: "light" | "dark" | "darkGradient" | "lightGradient") {
  return style.startsWith("dark") ? "primaryLightest" : "primary";
}

const Badge: React.FC<Props> = ({ text, style }) => {
  const backgroundColor = getBackgroundColor(style);
  const textColor = getTextColor(style);
  return (
    <Box backgroundColor={backgroundColor} borderRadius="default" px="s" py="xs">
      <Text as="h2" font="ui.smallBold" color={textColor}>
        {text}
      </Text>
    </Box>
  );
};

export default Badge;
